import type { Language } from "@app/constants";

interface Message {
	action: string;
	header: string;
	loginButton: string;
	warning: string;
}

type MessageData = {
	[key in Language]: Message;
};

const messages: MessageData = {
	en: {
		action: "Please log in.",
		header: "Account already exists",
		loginButton: "LOGIN",
		warning: "An account with matching credentials already exists.",
	},
};

export default messages;
